import { TranslationsMap } from '../services/i18n/translate';

export enum Theme {
  light = 'light',
  dark = 'dark',
}

export enum Audience {
  AllVisitors = 'all-visitors',
  EUVisitors = 'eu-visitors',
}

export type Timestamp = number;
export enum PrivacyPolicyType {
  PageOnSite = 'page-on-site',
  ExternalUrl = 'external-url',
}

export enum ButtonPositionType {
  BottomRight = 'bottom_right',
  BottomLeft = 'bottom_left',
  CenterRight = 'center_right',
  CenterLeft = 'center_left',
}

export type RevisitSettingsConfig = {
  enabled: boolean;
  buttonPosition?: ButtonPositionType;
};

export interface ISettings {
  texts: TranslationsMap;
  appEnabled: boolean;
  expiryDate?: Timestamp;
  theme: Theme;
  privacyPolicyType: PrivacyPolicyType;
  privacyPolicyPage: string;
  privacyPolicyUrl: string;
  audience: Audience;
  declineAllConfig?: DeclineAllConfig;
  revisitSettingsConfig?: RevisitSettingsConfig;
}

export type DeclineAllConfig = {
  enabled: boolean;
  geo?: string[];
};
